import { mapApiToMausoleum } from './map-api-to-mausoleum';
import { mapApiToPersonExtended } from './map-api-to-person-extended';

import type { IDeceased, IDeceasedApi } from 'src/interfaces';

export const mapApiToDeceased = ({
  lastname,
  firstname,
  middlename,
  nickname,
  suffix,
  title,
  dob,
  dod,
  grave = null,
  mausoleum = null,
  ...rest
}: IDeceasedApi): IDeceased => ({
  ...rest,
  ...mapApiToPersonExtended({ lastname, firstname, middlename, nickname, suffix, title, dob, dod }),
  grave,
  mausoleum: mausoleum ? mapApiToMausoleum(mausoleum) : null,
});
